import React, {useEffect, useState} from 'react';
import SignedInLinks from '../Component/Nav/SignedInLinks';
import SignedUpLinks from '../Component/Nav/SignedUpLinks';
import {useAuth0} from "../services/auth0";
import {Link} from "react-router-dom";

const logo = require('../assets/images/paradi_logo01 copy.png');

export default function Header(props) {
    const {user, getTokenSilently, getIdTokenClaims} = useAuth0();
    const [token, setAuthToken] = useState(localStorage.accessToken);
    const [userRole, setUserRole] = useState(localStorage.role || null);

    

    

    useEffect(() => {
        const setToken = async () => {
        const data = await getTokenSilently();
        const claims = await getIdTokenClaims();
        setAuthToken(data);
        setUserRole(claims['https://paradi.io/access']);
    };
        if (user && (!userRole || !token)) {
            setToken()
        }
    }, [user, getIdTokenClaims, getTokenSilently, token, userRole]);

    return (
        <header {...props}>
            <Link className="logo-wrapper" to="/">
                <img src={logo} width={150} alt=""/>
            </Link>
            <div className="button">
                {token ? (<SignedInLinks role={userRole}/>) : (<SignedUpLinks/>)}
            </div>
        </header>
    );
}